import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Asset from "@/pages/Asset";
import Rankings from "@/pages/Rankings";
import Markets from "@/pages/Markets";
import Europe from "@/pages/Europe";
import Correlations from "@/pages/Correlations";
import GlobalMacro from "@/pages/GlobalMacro";
import Compare from "@/pages/Compare";
import Portfolio from "@/pages/Portfolio";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center font-mono text-sm text-slate-500">initializing terminal…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Home />} />
              <Route path="/asset/:ticker" element={<Asset />} />
              <Route path="/rankings" element={<Rankings />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/europe" element={<Europe />} />
              <Route path="/correlations" element={<Correlations />} />
              <Route path="/global-macro" element={<GlobalMacro />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/portfolio-backtest" element={<Portfolio />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
